import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import EquipmentCodeIndMappingContMain from "presentation/view/container/EquipmentCodeIndMapping/EquipmentCodeIndMappingContMain";

CommonEntrypoint(<EquipmentCodeIndMappingContMain/>)